import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerComponent } from './progress-spinner.component';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { ProgressSpinnerService } from './progress-spinner.service';

@NgModule({
  declarations: [ProgressSpinnerComponent],
  imports: [CommonModule, MatProgressSpinnerModule],
  exports: [ProgressSpinnerComponent],
  providers: [ProgressSpinnerService],
})
export class ProgressSpinnerModule {
  constructor(private progressSpinnerService: ProgressSpinnerService) {
    this.progressSpinnerService.setupProgressListeners();
  }
}
